import { Link } from 'react-router-dom';
import EmptyCustomersImage from '@/assets/images/empty-customers.png';

const HELP_ARTICLE_URL =
    'https://help.stan.store/article/421-how-to-market-your-stan-store-increase-your-sales-like-a-pro';

/**
 * Custom Empty state shown when there are no customers
 */
export function CustomersEmptyState() {
    return (
        <div className='flex w-full flex-col items-center justify-center py-12 text-center'>
            <img src={EmptyCustomersImage} alt='Get your first customer' className='mb-6 size-84 h-auto' />

            <h2 className='text-dark mb-3 text-xl font-bold'>Get your first customer</h2>

            <Link to='/stores/' className='text-brand-main hover:text-brand-intense mb-2 font-medium transition-colors'>
                Launch and share paid products →
            </Link>

            <p className='text-gray text-sm'>
                Or learn how to grow your customer list{' '}
                <a
                    href={HELP_ARTICLE_URL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-dark underline hover:no-underline'
                >
                    here
                </a>
            </p>
        </div>
    );
}
